<template>
        <div>
            <document-list></document-list>
            <router-view></router-view>
        </div>
</template>

<script>
    import DocumentList from '../modules/components/DocumentList';

    export default {
        name: 'Home',
        components: {
            DocumentList,
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Documents.vue